'use client';

import { useTalentSharedGetCurrentSessionQueryQuery } from './graphql/GetCurrentSession.v5.generated';

export const useCrehanaCurrentSession = ({ skip }: { skip?: boolean }) => {
  const { data, loading } = useTalentSharedGetCurrentSessionQueryQuery({
    context: {
      clientName: 'v5',
    },
    skip,
  });

  // this will exists only if the current organization has the product learning active (full suite)
  const organizationId =
    (data?.security.current_session?.session_data.learning_session_data
      ?.organization_id as number) || undefined;
  const userId =
    (data?.security.current_session?.session_data.learning_session_data
      ?.user_id as number) || undefined;

  if (loading) {
    return {
      loading,
      data: undefined,
    };
  }

  if (organizationId && userId) {
    return {
      loading,
      data: { organizationId, userId },
    };
  }

  return {
    data: undefined,
    loading,
  };
};
